import { useTheme } from "@mui/material"
import { useTreeItemIndex } from "routes/schedule/lib/useTreeItemIndex"
import { idIndex } from "routes/schedule/lib/getTreeItemIndex"
import { ListItemBox } from "lib/@components/ListItemBox"
import AppWidget from "minimals-template/pages/sections/@dashboard/general/app/AppWidget"
import {
    MY_DRAFTS,
    MY_LIST,
    MY_PUBLISHED,
    MY_RETIRED,
} from "routes/schedule/my-schedules/my-custom-schedules/lib/constants"
import { navigate } from "lib/routes/navigate"
import { useSearchParam } from "lib/@hooks/use-search-param"

export function Summaries() {
    const theme = useTheme()
    const treeIndex = useTreeItemIndex()
    const [currentId] = useSearchParam("id", MY_LIST)
    const schedules = treeIndex[idIndex]
    const totals = Object.entries(schedules).reduce(
        (a, [key, list]) => {
            if (!key) return a
            if (!list.some((s) => s.custom)) return a
            a.total++
            if (list.some((s) => s.isRetired)) {
                a.retired++
            } else if (list.some((s) => s.isDraft)) {
                a.draft++
            } else {
                a.published++
            }

            return a
        },
        { total: 0, draft: 0, published: 0, retired: 0 }
    )

    return (
        <ListItemBox my={2} spacing={1} sx={{ m: "auto", maxWidth: 800, flexWrap: "wrap", justifyContent: "stretch" }}>
            <AppWidget
                data-cy="draft-summary"
                sx={activeSx(MY_DRAFTS, "info")}
                role="button"
                className="draft-schedules"
                aria-label="Draft Schedules"
                onClick={() => toggle(MY_DRAFTS)}
                title="Drafts"
                color="info"
                total={totals.draft}
                icon="mdi:file-document-edit-outline"
                chartData={{
                    series: [Math.round((totals.draft / (totals.total || Infinity)) * 100)],
                }}
            />

            <AppWidget
                data-cy="published-summary"
                sx={activeSx(MY_PUBLISHED, "success")}
                role="button"
                className="published-schedules"
                aria-label="Published Schedules"
                onClick={() => toggle(MY_PUBLISHED)}
                title="Published"
                color="success"
                total={totals.published}
                icon="mdi:file-document-outline"
                chartData={{
                    series: [Math.round((totals.published / (totals.total || Infinity)) * 100)],
                }}
            />

            <AppWidget
                data-cy="retired-summary"
                sx={activeSx(MY_RETIRED, "warning")}
                role="button"
                className="retired-schedules"
                aria-label="Retired Schedules"
                onClick={() => toggle(MY_RETIRED)}
                title="Retired"
                color="warning"
                total={totals.retired}
                icon="mdi:file-document-outline"
                chartData={{
                    series: [Math.round((totals.retired / (totals.total || Infinity)) * 100)],
                }}
            />
        </ListItemBox>
    )

    function toggle(target) {
        navigate(`/app/schedules?id=${currentId === target ? MY_LIST : target}`)
    }

    function activeSx(target, color) {
        if (currentId !== target) return { cursor: "pointer", flex: 1 }
        return {
            cursor: "pointer",
            flex: 1,
            outline: `2px solid ${theme.palette[color].main}`,
            outlineOffset: "-2px",
        }
    }
}
